import { useTransportMutation, useTransportQueryUtils } from "@/transport"
import { useQueryClient } from "@tanstack/react-query"

import { invalidateHomeQueries } from "@/lib/home-query-cache"
import type { AgentRecord } from "@/types/api/agent"

export function useDeleteAgentsTransport() {
  const queryUtils = useTransportQueryUtils()
  const queryClient = useQueryClient()

  return useTransportMutation("deleteAgents", {
    onMutate: () => queryUtils,
    onSuccess: (response, variables, originalQueryUtils) => {
      if (!originalQueryUtils) {
        return
      }
      const requested = new Set(variables.ids)
      const deleted = new Set(
        response.results
          .filter((result) => result.success && requested.has(result.id))
          .map((result) => result.id),
      )
      for (const operation of ["listAgents", "listAllAgents"] as const) {
        originalQueryUtils.updatePaginatedOperationData(
          operation,
          (agents: AgentRecord[] | undefined) =>
            agents?.filter((agent) => !deleted.has(agent.id)),
        )
      }
    },
    onSettled: (_response, error, _variables, originalQueryUtils) => {
      if (error || !originalQueryUtils) {
        return
      }
      for (const operation of ["listAgents", "listAllAgents"] as const) {
        void originalQueryUtils.invalidatePaginatedOperation(operation, {
          refetchType: "none",
        })
      }
      void originalQueryUtils.invalidateOperation("listRecentlyDeletedAgents")
      void invalidateHomeQueries(queryClient)
    },
  })
}
